/**
 * A length of time typed as an amount and a unit, as the Licenses page's dialogs take it: the
 * offline credit window and budget, and the seat time. One copy, so both read and round a value
 * the same way.
 */
export const UNITS = { min: 60, h: 3600, d: 86400 } as const;
export type Unit = keyof typeof UNITS;

/** A stored value as the largest unit it is a whole number of. */
export const toField = (seconds: number | undefined): { amount: string, unit: Unit } => {
  if (seconds === undefined) return { amount: '', unit: 'h' };
  if (seconds !== 0 && seconds % UNITS.d === 0) return { amount: String(seconds / UNITS.d), unit: 'd' };
  if (seconds % UNITS.h === 0) return { amount: String(seconds / UNITS.h), unit: 'h' };

  return { amount: String(Math.round(seconds / UNITS.min)), unit: 'min' };
};

export interface ValueField {
  /** Unticked: no admin value, the licence file's value applies. */
  own: boolean;
  amount: string;
  unit: Unit;
}

export const fieldFrom = (seconds: number | undefined): ValueField => ({ own: seconds !== undefined, ...toField(seconds) });

/** Whole seconds, or undefined when the amount is not a number of 0 or more. */
export const secondsOf = (field: ValueField): number | undefined => {
  const amount = Number(field.amount);

  if (field.amount.trim() === '' || !Number.isFinite(amount) || amount < 0) return undefined;

  // Rounded to the second, as the control panel does: 1.1 hours is 3960.0000000000005 seconds in
  // floating point, which no whole-number check accepts.
  return Math.round(amount * UNITS[field.unit]);
};
